var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPlaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7109 22.124V35.8732L3.68533 38.9838L4.04526 22.124",
    fill: "url(#paint0_linear_1918_2838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 21.917V35.6073L3.72351 38.9489L3.95719 21.917",
    fill: "url(#paint1_linear_1918_2838)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72314 22.043V39.0735L10.7688 35.6663V22.043H3.72314Z",
    fill: "url(#paint2_linear_1918_2838)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.72314 22.043V39.0735L10.7688 35.6663V22.043H3.72314Z",
    fill: "url(#paint3_radial_1918_2838)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5068 22.124V35.8732L28.6579 39.1298L28.26 22.124",
    fill: "url(#paint4_linear_1918_2838)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2988 21.917V35.6073L28.6576 39.1304L28.3441 21.917",
    fill: "url(#paint5_linear_1918_2838)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2007 21.8057L28.6582 39.1281L21.0638 35.4769L21.1551 21.8057H28.2007Z",
    fill: "url(#paint6_linear_1918_2838)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.2007 21.8057L28.6582 39.1281L21.0638 35.4769L21.1551 21.8057H28.2007Z",
    fill: "url(#paint7_radial_1918_2838)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7054 21.8086V40.6869L16.0774 43.2784L10.4521 40.6869V21.8086H21.7054Z",
    fill: "url(#paint8_linear_1918_2838)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.7054 21.8086V40.6869L16.0774 43.2784L10.4521 40.6869V21.8086H21.7054Z",
    fill: "url(#paint9_radial_1918_2838)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4806 21.9996V40.5719L16.0774 43.0605L10.6769 40.5719V21.9996H21.4806ZM21.7054 21.808H10.4521V40.6864L16.0774 43.2778L21.7054 40.684V21.8057V21.808Z",
    fill: "url(#paint10_linear_1918_2838)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.732429C15.5235 0.285847 16.4765 0.285848 17.25 0.73243L29.9054 8.03905C30.6789 8.48564 31.1554 9.31095 31.1554 10.2041V24.8174C31.1554 25.7105 30.6789 26.5358 29.9054 26.9824L17.25 34.2891C16.4765 34.7356 15.5235 34.7356 14.75 34.2891L2.09455 26.9824C1.32105 26.5358 0.844556 25.7105 0.844556 24.8174V10.2041C0.844556 9.31095 1.32105 8.48564 2.09456 8.03905L14.75 0.732429Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.732429C15.5235 0.285847 16.4765 0.285848 17.25 0.73243L29.9054 8.03905C30.6789 8.48564 31.1554 9.31095 31.1554 10.2041V24.8174C31.1554 25.7105 30.6789 26.5358 29.9054 26.9824L17.25 34.2891C16.4765 34.7356 15.5235 34.7356 14.75 34.2891L2.09455 26.9824C1.32105 26.5358 0.844556 25.7105 0.844556 24.8174V10.2041C0.844556 9.31095 1.32105 8.48564 2.09456 8.03905L14.75 0.732429Z",
    fill: "url(#paint11_linear_1918_2838)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "url(#paint12_linear_1918_2838)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7502 4.06544C15.5237 3.61886 16.4767 3.61886 17.2502 4.06544L27.0189 9.70539C27.7924 10.152 28.2689 10.9773 28.2689 11.8705V23.1504C28.2689 24.0435 27.7924 24.8689 27.0189 25.3154L17.2502 30.9554C16.4767 31.402 15.5237 31.402 14.7502 30.9554L4.98147 25.3154C4.20797 24.8689 3.73147 24.0435 3.73147 23.1504V11.8705C3.73147 10.9773 4.20797 10.152 4.98147 9.7054L14.7502 4.06544Z",
    fill: "url(#paint13_radial_1918_2838)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4309 13.0888H12.4069V10.4788H18.2209V23.7988H15.4309V13.0888Z",
    fill: "#FDFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1918_2838",
    x1: 10.5142,
    y1: 26.2988,
    x2: 0.316263,
    y2: 29.1075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#99DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234907,
    stopColor: "#BDDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#D0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747552,
    stopColor: "#C4C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#848DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1918_2838",
    x1: 1.07716,
    y1: 25.6879,
    x2: 17.1627,
    y2: 37.8302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FC9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E7EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#335FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#285FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0F3C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1918_2838",
    x1: 1.58069,
    y1: 21.5392,
    x2: 16.2999,
    y2: 26.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#FFCE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#DBB32E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#70500F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1918_2838",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.24596 30.5582) scale(7.14445 14.0036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E0A4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BB510F",
    stopOpacity: 0.498
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1918_2838",
    x1: 21.7062,
    y1: 26.2988,
    x2: 32.0187,
    y2: 29.1764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#99DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234907,
    stopColor: "#BDDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#D0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747552,
    stopColor: "#C4C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#848DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1918_2838",
    x1: 31.2241,
    y1: 25.6879,
    x2: 15.1386,
    y2: 37.8302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FC9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E7EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#335FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#285FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0F3C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1918_2838",
    x1: 30.9675,
    y1: 21.2933,
    x2: 15.2898,
    y2: 26.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#FFCE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#DBB32E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#70500F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1918_2838",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.861 30.4669) rotate(-180) scale(7.70091 14.2437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E0A4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BB510F",
    stopOpacity: 0.498
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1918_2838",
    x1: 7.03023,
    y1: 21.1735,
    x2: 29.2304,
    y2: 30.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#FFCE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#DBB32E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#70500F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1918_2838",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0788 32.5435) scale(11.4111 17.6539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E0A4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BB510F",
    stopOpacity: 0.498
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1918_2838",
    x1: 16.0801,
    y1: 46.1519,
    x2: 16.0801,
    y2: 33.9543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C5F7F9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C6F6F9",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D3F6F9",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DEF5FA",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E7F4FB",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EDF4FB",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F0F4FB",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F4FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1918_2838",
    x1: -0.541423,
    y1: 8.55312,
    x2: 36.8356,
    y2: 33.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#99DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234907,
    stopColor: "#BDDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#D0C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747552,
    stopColor: "#C4C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#848DC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1918_2838",
    x1: -6.7822,
    y1: 2.50567,
    x2: 33.4306,
    y2: 34.4468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0648623,
    stopColor: "#FFF7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#FFC918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913698,
    stopColor: "#E89A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1918_2838",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0002 17.5104) scale(28.7308 23.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E0A4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#874600",
    stopOpacity: 0.498
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPlaceIcon);
export default __webpack_public_path__ + "static/media/firstPlaceIcon.3f2cfd9c8900748e459f048d3efbd8e4.svg";
export { ForwardRef as ReactComponent };